import axios from "axios";

export var invalidEmailAddresses: string[] = [];

const getInvalidEmailAddresses = async () => {
  await axios
    .get<string[]>("/enrolments/invalid_email_addresses")
    .then((response) => {
      if (response.status !== 200) {
        console.log("Failed to fetch invalid email addresses");
      } else {
        invalidEmailAddresses = response.data;
      }
    })
    .catch((error) => {
      console.log("Error fetching invalid email addresses: ", error);
    });
};

getInvalidEmailAddresses();
